import Form from 'Components/Forms/FormGenerator';
import FormViewer from 'Components/FormViewer';
import { actions as measurementActions } from 'ducks/measurements';
import React from 'react';
import { useSelector } from 'react-redux';
import { metadataFields, serializeForm } from 'utils/forms/utils';
import validators from 'utils/forms/validators';
import { getMeasurementMetadata } from 'utils/getMetadata.js';
import sortMeasurements from 'utils/sortMeasurements';

const Component = props => {
    const { device, readingId } = props;
    const { closeDrawer } = props;

    const formSchema = [];

    const devices = useSelector(state => state.devices.models);
    const equipment = useSelector(state => state.equipments.models[device.equipment_id]);
    const measurements = useSelector(state => state.measurements.models);
    const reading = useSelector(state => state.readings.models[readingId]);
    const submitting = useSelector(state => state.measurements.submitting);

    const rootDevice = useSelector(state => state.devices.models[device.root_device_id]);
    const metadata = getMeasurementMetadata(device, rootDevice);

    const create = measurementActions.useCreate();

    if (['wise_input', 'wise_current'].includes(device.equipment_category_slug) || equipment.equipment_type_slug === 'input_sensor') {
        formSchema.push(
            {
                label: 'Name\x2a',
                name: 'name',
                type: 'text',
                validate: [validators.required]
            }
        );
    }

    if (device.equipment_category_slug === 'digital_meter') {
        const usedPortIds = [];

        Object.values(measurements).forEach(measurement => {
            if (measurement.port_id && devices[measurement.device_id].parent_id === device.parent_id) {
                usedPortIds.push(measurement.port_id);
            }
        });

        const availablePorts = Object.values(measurements).filter(measurement => measurement.device_id === device.parent_id && !usedPortIds.includes(measurement.id)).sort(sortMeasurements);

        formSchema.push({
            formData: availablePorts,
            label: 'Connected Port\x2a',
            name: 'port_id',
            type: 'select',
            validate: [validators.required]
        });
    }

    formSchema.push(...metadataFields(metadata));

    const onSubmit = formValues => {
        let data = {
            ...serializeForm(formValues, formSchema),
            device_id: device.id,
            reading_id: reading.id
        };

        create(data, closeDrawer);
    };

    return (
        <FormViewer label="Add Measurement">
            <Form
                formInitialValues={{ metadata_values: [], name: reading.name }}
                formSchema={formSchema}
                isSubmitting={submitting}
                onSubmit={onSubmit}
            />
        </FormViewer>
    );
};

export default Component;
